import { dispatcher } from 'dispatcher';

export const GAME_LAUNCH_TYPE = {
    Casino: 'Casino',
    Default: 'Default'
};

export const useCasinoLaunchMechanism = (data) => {
    if (window.parent) {
        // in case game is launched from NGM CP or GDK
        window.parent.postMessage({
            _type: 'com.pt.casino.client.integration.overlay.OpenGameNotification',
            gameCode: data.code
        }, document.referrer || document.location.href);
    }
};

export const useDefaultLaunchMechanism = (data) => {
    dispatcher.dispatch('game:launch', data);
};

export default (data) => {
    switch (data.gameLaunchType) {
        case GAME_LAUNCH_TYPE.Casino:
            useCasinoLaunchMechanism(data);
            return;

        default:
            useDefaultLaunchMechanism(data);
    }
};
